module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/cv_2_sp_16fe20f8d49ed71ca80c9eb960cf13f0.jpg";